module.exports = __webpack_public_path__ + "img/2.877bf421.svg";